import { HStack, BoxProps, Divider } from '@chakra-ui/react';
export const PageFooter = (props: BoxProps) => (
  <>
    <Divider pt='6' pb='0' />
    <HStack as='footer' size='lg' py='4' {...props} />
  </>
);
